// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const UserMd = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M4.1665 17.5C4.1665 14.2783 6.77818 11.6667 9.99984 11.6667C13.2215 11.6667 15.8332 14.2783 15.8332 17.5M13.3332 5.83333C13.3332 7.67428 11.8408 9.16667 9.99984 9.16667C8.15889 9.16667 6.6665 7.67428 6.6665 5.83333C6.6665 3.99238 8.15889 2.5 9.99984 2.5C11.8408 2.5 13.3332 3.99238 13.3332 5.83333Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);
